// 供应商产品管理
export const supplierProductMngRouter = [
  {
    path: '/supplierProductMng/commodityAllocationMng',
    name: 'commodityAllocationMng',
    component: () => import('../views/supplierProductMng/commodityAllocationMng')
  },
  {
    path: '/supplierProductMng/SupplyinfoSee',
    name: 'SupplyinfoSee',
    component: () => import('../views/supplierProductMng/SupplyinfoSee')
  },
]